module.exports = __webpack_public_path__ + "static/media/arrow.3d45f423.svg";